import { createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Submitted Tenant References")
const _hoisted_2 = {
  key: 0,
  class: "d-flex flex-column gap-5"
}
const _hoisted_3 = { class: "w-100 bg-white p-5" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "text-capitalize ms-3" }
const _hoisted_6 = {
  key: 0,
  class: "red-flag ms-3"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-flag-fill text-danger" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_10 = { class: "text-capitalize" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "text-capitalize" }
const _hoisted_13 = { class: "d-flex align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_TenantAvatar = _resolveComponent("TenantAvatar")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_rate = _resolveComponent("el-rate")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { class: "agency-container" }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    subtitle: _withCtx(() => [
      _createTextVNode("Found " + _toDisplayString(_ctx.table.total) + " tenant references", 1)
    ]),
    default: _withCtx(() => [
      (!_ctx.table.items.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_skeleton, {
                animated: "",
                row: "5"
              })
            ])
          ]))
        : (_openBlock(), _createBlock(_component_DataTable, {
            key: 1,
            "table-data": _ctx.table.items,
            "table-header": _ctx.tableHeaders,
            ordering: _ctx.table.ordering,
            "onClick:row": _ctx.viewReport,
            "row-class": "table-hover"
          }, {
            "cell-name": _withCtx(({ row: item }) => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_router_link, {
                  to: {
              name: 'view-tenant-reference',
              params: {
                tenant_id: item.tenant.id,
                tenant_ref_id: item.reference_no,
              },
            },
                  class: "d-flex align-items-center",
                  style: {"color":"inherit !important"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_TenantAvatar, {
                      imageFile: item.avatar,
                      acronym: item.acronym,
                      useIcon: false
                    }, null, 8, ["imageFile", "acronym"]),
                    _createElementVNode("span", _hoisted_5, _toDisplayString(item.tenant.first_name) + " " + _toDisplayString(item.tenant.last_name), 1),
                    (item.is_flagged === 'yes')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _hoisted_8))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ])
            ]),
            "cell-agency": _withCtx(({ row: item }) => [
              (item.user.business_name)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(item.user.business_name), 1)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_11, "Not Specified"))
            ]),
            "cell-date": _withCtx(({ row: item }) => [
              _createTextVNode(_toDisplayString(_ctx.$filters.formatDate(item.date, 'aus')), 1)
            ]),
            "cell-agent_name": _withCtx(({ row: item }) => [
              _createElementVNode("span", _hoisted_12, _toDisplayString(item.user.first_name) + " " + _toDisplayString(item.user.last_name), 1)
            ]),
            "cell-rating": _withCtx(({ row: item }) => [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_el_form_item, { class: "mb-0" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_rate, {
                      class: "rating-size",
                      "model-value": 1,
                      disabled: "",
                      max: "1"
                    })
                  ]),
                  _: 1
                }),
                _createTextVNode(" " + _toDisplayString(parseFloat(item.average_rating).toFixed(1)), 1)
              ])
            ]),
            _: 1
          }, 8, ["table-data", "table-header", "ordering", "onClick:row"]))
    ]),
    _: 1
  }))
}